export const bacteriaLayoutConfig_bwcdiamond_eng = [
    {
        label: 'Bacillus genus',
        page: 5,
        yOffset: 200,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 190,
        yResult: 190,
        yResulttext: 194,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Candida albicans',
        page: 5,
        yOffset: 239,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 229,
        yResult: 229,
        yResulttext: 233,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Clostridium difficile',
        page: 5,
        yOffset: 278,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 268,
        yResult: 268,
        yResulttext: 272,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Escherichia coli',
        page: 5,
        yOffset: 317,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 307,
        yResult: 307,
        yResulttext: 311,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Staphylococcus aureus',
        page: 5,
        yOffset: 356,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 346,
        yResult: 346,
        yResulttext: 350,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Akkermansia muciniphila',
        page: 5,
        yOffset: 437,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 427,
        yResult: 427,
        yResulttext: 431,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Alistipes putredinis',
        page: 5,
        yOffset: 476,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 466,
        yResult: 466,
        yResulttext: 470,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Bacteroides genus',
        page: 5,
        yOffset: 515,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 505,
        yResult: 505,
        yResulttext: 509,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Bacteroides fragilis',
        page: 5,
        yOffset: 554,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 544,
        yResult: 544,
        yResulttext: 548,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Faecalibacterium prausnitzii',
        page: 5,
        yOffset: 593,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 583,
        yResult: 583,
        yResulttext: 587,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Roseburia hominis',
        page: 5,
        yOffset: 632,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 622,
        yResult: 622,
        yResulttext: 626,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Bifidobacterium bifidum',
        page: 6,
        yOffset: 175,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 165,
        yResult: 165,
        yResulttext: 169,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Bifidobacterium breve',
        page: 6,
        yOffset: 214,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 204,
        yResult: 204,
        yResulttext: 208,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Bifidobacterium lactis',
        page: 6,
        yOffset: 253,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 243,
        yResult: 243,
        yResulttext: 247,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Bifidobacterium longum',
        page: 6,
        yOffset: 292,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 282,
        yResult: 282,
        yResulttext: 286,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Lactobacillus acidophilus',
        page: 6,
        yOffset: 331,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 321,
        yResult: 321,
        yResulttext: 325,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Lactobacillus gasseri',
        page: 6,
        yOffset: 370,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 360,
        yResult: 360,
        yResulttext: 364,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Lactobacillus helveticus',
        page: 6,
        yOffset: 409,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 399,
        yResult: 399,
        yResulttext: 403,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Lactobacillus paracasei',
        page: 6,
        yOffset: 448,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 438,
        yResult: 438,
        yResulttext: 442,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Lactobacillus plantarum',
        page: 6,
        yOffset: 487,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 477,
        yResult: 477,
        yResulttext: 481,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Lactobacillus reuteri',
        page: 6,
        yOffset: 526,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 516,
        yResult: 516,
        yResulttext: 520,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Lactobacillus rhamnosus',
        page: 6,
        yOffset: 565,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 555,
        yResult: 555,
        yResulttext: 559,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Streptococcus thermophilus',
        page: 6,
        yOffset: 604,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 594,
        yResult: 594,
        yResulttext: 598,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Bacillus genus',
        page: 10,
        yOffset: 110,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 100,
        yResult: 594,
        yResulttext: 104,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Candida albicans',
        page: 10,
        yOffset: 297,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 287,
        yResult: 594,
        yResulttext: 291,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Clostridium difficile',
        page: 10,
        yOffset: 482,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 472,
        yResult: 594,
        yResulttext: 476,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Escherichia coli',
        page: 10,
        yOffset: 640,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 630,
        yResult: 594,
        yResulttext: 634,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Staphylococcus aureus',
        page: 11,
        yOffset: 72,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 62,
        yResult: 594,
        yResulttext: 66,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Akkermansia muciniphila',
        page: 11,
        yOffset: 392,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 382,
        yResult: 594,
        yResulttext: 386,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Alistipes putredinis',
        page: 11,
        yOffset: 575,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 565,
        yResult: 594,
        yResulttext: 569,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Bacteroides genus',
        page: 11,
        yOffset: 758,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 748,
        yResult: 594,
        yResulttext: 752,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Bacteroides fragilis',
        page: 12,
        yOffset: 78,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 68,
        yResult: 594,
        yResulttext: 72,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Faecalibacterium prausnitzii',
        page: 12,
        yOffset: 285,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 275,
        yResult: 594,
        yResulttext: 279,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Roseburia hominis',
        page: 12,
        yOffset: 575,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 565,
        yResult: 594,
        yResulttext: 569,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Bifidobacterium bifidum',
        page: 13,
        yOffset: 120,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 110,
        yResult: 594,
        yResulttext: 114,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Bifidobacterium breve',
        page: 13,
        yOffset: 380,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 370,
        yResult: 594,
        yResulttext: 374,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Bifidobacterium lactis',
        page: 13,
        yOffset: 662,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 652,
        yResult: 594,
        yResulttext: 656,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Bifidobacterium longum',
        page: 14,
        yOffset: 80,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 70,
        yResult: 594,
        yResulttext: 74,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Lactobacillus acidophilus',
        page: 14,
        yOffset: 315,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 305,
        yResult: 594,
        yResulttext: 309,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Lactobacillus gasseri',
        page: 14,
        yOffset: 575,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 565,
        yResult: 594,
        yResulttext: 569,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Lactobacillus helveticus',
        page: 15,
        yOffset: 80,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 70,
        yResult: 594,
        yResulttext: 74,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Lactobacillus helveticus',
        page: 15,
        yOffset: 80,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 70,
        yResult: 594,
        yResulttext: 74,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Lactobacillus paracasei',
        page: 15,
        yOffset: 338,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 328,
        yResult: 594,
        yResulttext: 332,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Lactobacillus plantarum',
        page: 15,
        yOffset: 602,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 592,
        yResult: 594,
        yResulttext: 596,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Lactobacillus reuteri',
        page: 16,
        yOffset: 80,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 70,
        yResult: 594,
        yResulttext: 74,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Lactobacillus rhamnosus',
        page: 16,
        yOffset: 322,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 312,
        yResult: 594,
        yResulttext: 316,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Streptococcus thermophilus',
        page: 17,
        yOffset: 80,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 70,
        yResult: 594,
        yResulttext: 74,
        xResulttext: 565,  
        show_result: false
    },
];

export const bacteriaLayoutConfig_bwcdiamond_thai = [
    {
        label: 'Bacillus genus',
        page: 4,
        yOffset: 200,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 190,
        yResult: 190,
        yResulttext: 194,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Candida albicans',
        page: 4,
        yOffset: 239,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 229,
        yResult: 229,
        yResulttext: 233,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Clostridium difficile',
        page: 4,
        yOffset: 278,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 268,
        yResult: 268,
        yResulttext: 272,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Escherichia coli',
        page: 4,
        yOffset: 317,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 307,
        yResult: 307,
        yResulttext: 311,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Staphylococcus aureus',
        page: 4,
        yOffset: 356,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 346,
        yResult: 346,
        yResulttext: 350,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Akkermansia muciniphila',
        page: 4,
        yOffset: 437,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 427,
        yResult: 427,
        yResulttext: 431,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Alistipes putredinis',
        page: 4,
        yOffset: 476,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 466,
        yResult: 466,
        yResulttext: 470,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Bacteroides genus',
        page: 4,
        yOffset: 515,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 505,
        yResult: 505,
        yResulttext: 509,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Bacteroides fragilis',
        page: 4,
        yOffset: 554,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 544,
        yResult: 544,
        yResulttext: 548,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Faecalibacterium prausnitzii',
        page: 4,
        yOffset: 593,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 583,
        yResult: 583,
        yResulttext: 587,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Roseburia hominis',
        page: 4,
        yOffset: 632,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 622,
        yResult: 622,
        yResulttext: 626,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Bifidobacterium bifidum',
        page: 5,
        yOffset: 175,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 165,
        yResult: 165,
        yResulttext: 169,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Bifidobacterium breve',
        page: 5,
        yOffset: 214,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 204,
        yResult: 204,
        yResulttext: 208,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Bifidobacterium lactis',
        page: 5,
        yOffset: 253,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 243,
        yResult: 243,
        yResulttext: 247,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Bifidobacterium longum',
        page: 5,
        yOffset: 292,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 282,
        yResult: 282,
        yResulttext: 286,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Lactobacillus acidophilus',
        page: 5,
        yOffset: 331,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 321,
        yResult: 321,
        yResulttext: 325,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Lactobacillus gasseri',
        page: 5,
        yOffset: 370,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 360,
        yResult: 360,
        yResulttext: 364,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Lactobacillus helveticus',
        page: 5,
        yOffset: 409,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 399,
        yResult: 399,
        yResulttext: 403,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Lactobacillus paracasei',
        page: 5,
        yOffset: 448,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 438,
        yResult: 438,
        yResulttext: 442,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Lactobacillus plantarum',
        page: 5,
        yOffset: 487,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 477,
        yResult: 477,
        yResulttext: 481,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Lactobacillus reuteri',
        page: 5,
        yOffset: 526,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 516,
        yResult: 516,
        yResulttext: 520,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Lactobacillus rhamnosus',
        page: 5,
        yOffset: 565,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 555,
        yResult: 555,
        yResulttext: 559,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Streptococcus thermophilus',
        page: 5,
        yOffset: 604,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 594,
        yResult: 594,
        yResulttext: 598,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Bacillus genus',
        page: 9,
        yOffset: 115,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 105,
        yResult: 594,
        yResulttext: 109,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Candida albicans',
        page: 9,
        yOffset: 297,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 287,
        yResult: 594,
        yResulttext: 291,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Clostridium difficile',
        page: 9,
        yOffset: 482,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 472,
        yResult: 594,
        yResulttext: 476,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Escherichia coli',
        page: 9,
        yOffset: 645,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 635,
        yResult: 594,
        yResulttext: 639,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Staphylococcus aureus',
        page: 10,
        yOffset: 72,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 62,
        yResult: 594,
        yResulttext: 66,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Akkermansia muciniphila',
        page: 10,
        yOffset: 342,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 332,
        yResult: 594,
        yResulttext: 336,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Alistipes putredinis',
        page: 10,
        yOffset: 500,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 490,
        yResult: 400,
        yResulttext: 494,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Bacteroides genus',
        page: 10,
        yOffset: 704,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 694,
        yResult: 594,
        yResulttext: 698,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Bacteroides fragilis',
        page: 11,
        yOffset: 78,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 68,
        yResult: 594,
        yResulttext: 72,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Faecalibacterium prausnitzii',
        page: 11,
        yOffset: 285,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 275,
        yResult: 594,
        yResulttext: 279,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Roseburia hominis',
        page: 11,
        yOffset: 519,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 509,
        yResult: 594,
        yResulttext: 513,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Bifidobacterium bifidum',
        page: 12,
        yOffset: 125,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 115,
        yResult: 594,
        yResulttext: 119,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Bifidobacterium breve',
        page: 12,
        yOffset: 380,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 370,
        yResult: 594,
        yResulttext: 374,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Bifidobacterium lactis',
        page: 12,
        yOffset: 662,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 652,
        yResult: 594,
        yResulttext: 656,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Bifidobacterium longum',
        page: 13,
        yOffset: 80,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 70,
        yResult: 594,
        yResulttext: 74,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Lactobacillus acidophilus',
        page: 13,
        yOffset: 342,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 332,
        yResult: 594,
        yResulttext: 336,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Lactobacillus gasseri',
        page: 13,
        yOffset: 605,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 595,
        yResult: 594,
        yResulttext: 599,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Lactobacillus helveticus',
        page: 14,
        yOffset: 80,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 70,
        yResult: 594,
        yResulttext: 74,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Lactobacillus paracasei',
        page: 14,
        yOffset: 338,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 328,
        yResult: 594,
        yResulttext: 332,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Lactobacillus plantarum',
        page: 14,
        yOffset: 650,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 640,
        yResult: 594,
        yResulttext: 644,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Lactobacillus reuteri',
        page: 15,
        yOffset: 80,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 70,
        yResult: 594,
        yResulttext: 74,
        xResulttext: 565,  
        show_result: false
    },
    {
        label: 'Lactobacillus rhamnosus',
        page: 15,
        yOffset: 322,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 312,
        yResult: 594,
        yResulttext: 316,
        xResulttext: 565,  
        show_result: false
    },
];